module.exports = __webpack_public_path__ + "img/ic-voucher.887e564f.svg";